import {
  ChangeDetectorRef,
  Component,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { AuthService } from 'src/app/modules/auth/services/auth.service';
import { Web3Service } from '../../services/web3.service';
import { environment } from 'src/environments/environment';
import { ToastrService } from 'ngx-toastr';
import { AvailableNetworks, networkData } from 'src/assets/networkConfig';
import { StoreService } from '../../services/network.service';
import { LocalStorageService } from '../../../modules/auth/services/local-storage.service';
import { NftService } from '../../../../app/modules/nft/services/nft.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

declare global {
  interface Window {
    ethereum: any;
  }
}

// window.ethereum.on('accountsChanged', () => {
//   setTimeout(() => {
//     location.reload();
//   }, 400);
// });

// window.ethereum.on('chainChanged', () => {
//   setTimeout(() => {
//     location.reload();
//   }, 400);
// });
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  loggedIn$: Observable<boolean>;
  signedIn: Boolean = false;
  connected: Boolean = false;
  started: Boolean = false;
  selectedPage = '';
  networkId = '';
  redirectUrl: any;
  testBtns = '';
  switchNetwork = '';
  showConnectButton: Boolean = true;
  isDark: Boolean = false;
  showModal: Boolean = true;
  selectedNetwork: AvailableNetworks = AvailableNetworks.polygon;
  allAvailableNetworks = Object.values(AvailableNetworks);
  networkData = networkData;
  networkDiff: any;
  networkName: any;
  connectButton: any;
  walletAddressCheck: any;
  myItem: any;
  isLoginButton: any = false;
  onHomePage: Boolean = false;
  onIndiaLendPage: Boolean = false;
  showWalletBtn: any = true;
  userProfileData: any = {};
  // public storageSubObs: Observable<any>

  constructor(
    public router: Router,
    private authService: AuthService,
    private cd: ChangeDetectorRef,
    private web3Service: Web3Service,
    private toastr: ToastrService,
    private _storeService: StoreService,
    private localStorage: LocalStorageService,
    private nftService: NftService,
    private modalService: NgbModal
  ) {
    this.checkIfLoggedIn();
    console.log('&&&&&&&&&&&&&', !window.location.href.includes('india'));
    this.showWalletBtn = !window.location.href.includes('india');
  
    console.log('76767676766767676767', window.location.href);

    console.log(window.location.href.split('/')[3]);
    if (window.location.href.split('/')[3] == 'home') {
      this.onHomePage = true;
    } else {
      this.onHomePage = false;
    }
    if (window.location.href.split('/')[5] == 'india') {
      this.onIndiaLendPage = true;
    } else {
      this.onIndiaLendPage = false;
    }

    // this.isLoginButton = JSON.parse(localStorage.getItem('isLoginButton'));
    // this.checkConnectionAndLoadData();
    // this.storageSubObs = this.loggedIn$.asObservable();
    this.authService.loggedIn$.subscribe(() => {
      console.log('%c Line:79 🍺 value', 'color:#ea7e5c');
      // console.log('%c Line:77 🍅 val', 'color:#465975');
      this.checkIfLoggedIn();
      let checkState = this.authService.getLoginState().subscribe;
      console.log('%c Line:82 🎂 checkState', 'color:#7f2b82', checkState);
      // if (checkState.source._value) this.signedIn = true;
    });

    // let token = await this.authService.loadToken().valueChanges.subscribe();
    // let tokenData = localStorage.getItem('token').valueChanges.subscribe;
  }

  async checkIfLoggedIn() {
    let token = await this.authService.loadToken();
    console.log('token+', token);
    if (token) {
      console.log(
        '%c Line:93 🥥 this.authService.getLoginState()',
        'color:#ed9ec7',
        this.authService.getLoginState()
      );
      this.signedIn = true;
      this.loadProfileData();
    }
  }

  async loadProfileData() {
    let token = await this.authService.loadToken();
    this.nftService.getUserProfile(token).subscribe((response: any) => {
      console.log('%c Line:63 🍷 response', 'color:#33a5ff', response);
      localStorage.setItem('user', JSON.stringify(response.data.user));
      this.userProfileData = response.data.user;
    });
  }

  async showProfile(content) {
    await this.modalService.open(content, {
      ariaLabelledBy: 'modal-basic-title',
    }).result;
    return;
  }
  // DARK MODE
  toggleDarkTheme(): void {
    document.body.classList.toggle('dark-theme');
    this.isDark = !this.isDark;
  }

  // async checkConnectionAndLoadData() {
  //   let accounts = await this.web3Service.checkConnection();
  //   console.log(accounts);
  //   if (!accounts) {
  //     this.router.navigateByUrl('/home');
  //   }
  //   this.networkId = accounts[0] || '';
  //   console.log(this.networkId);
  //   if (this.networkId) {
  //     // this.refreshData();
  //   } else {
  //     this.router.navigateByUrl('/home');
  //     this.cd.detectChanges();
  //   }
  // }

  ngOnInit(): void {
    this.checkConnection();
    this.getToken();
    this.localStorage.onStorageEvent().subscribe((key: string) => {
      if (key === 'myKey') {
        this.myItem = this.localStorage.getItem('myKey');
      }
    });
    this._storeService.network$.subscribe((network) => {
      this.selectedNetwork = network;
    });
    this._storeService.networkDiff$.subscribe((networkdiff) => {
      console.log('networkdiff', networkdiff);
      this.networkDiff = networkdiff;
      console.log('after setting', this.networkDiff);
      this.checkConnection();
      this.cd.detectChanges();
      this.walletAddressCheck = localStorage.getItem('walletaddress');
    });
    // this.checkIfLoggedIn();
  }
  async checkConnection() {
    this.networkName = networkData[AvailableNetworks.polygon].name;
    let accounts = await this.web3Service.checkConnection();
    console.log(accounts, 'accounts here');
    this.networkId = accounts[0] || '';
    console.log(this.networkId);
    if (this.networkId) {
      this.connected = true;
    }
    let provider = await this.web3Service.checkConnectionStutus();
    if (provider) {
      if (provider.chainId == networkData[AvailableNetworks.polygon].chainId) {
        console.log('connected');
        provider.on('accountsChanged', (accounts: string[]) => {
          console.log('inside the accountChanged event listener');
          if (accounts.length > 0) {
            this.connected = true;
          } else {
            this.connected = false;
          }
          console.log('connected', this.connected);
          this.cd.detectChanges();
        });
      } else {
        this.networkDiff = true;
      }
    }
  }
  // navBarCheck() {
  //   switch (this.router.url) {
  //     case '/home':
  //       this.started = false;
  //       this.connected = false;
  //       this.showConnectButton = false;
  //       break;
  //     case '/home/connect':
  //       this.started = true;
  //       this.connected = true;
  //       this.showConnectButton = true;
  //       break;
  //     case '/home/lending':
  //       this.started = true;
  //       this.selectedPage = 'lend';
  //       this.connected = true;
  //       break;
  //     case '/home/borrow':
  //       this.started = true;
  //       this.connected = true;
  //       this.selectedPage = 'borrow';
  //       break;
  //     case '/home/my-transactions':
  //       this.started = true;
  //       this.connected = true;
  //       this.selectedPage = '';
  //       break;

  //     default:
  //       break;
  //   }
  // }

  onLogout() {
    this.authService.logout().subscribe(() => {
      // this.localStorage.setData(false);
      this.router.navigateByUrl('/auth/login');
    });
  }
  close() {
    this.modalService.dismissAll();
  }

  onChange(value: string) {
    console.log('the selected value is ' + value);
    if (value == 'lend') {
      this.router.navigateByUrl('/home/lending');
    }
    if (value == 'borrow') {
      this.router.navigateByUrl('/home/borrow');
    }
  }
  onChangeTBtns(value: string) {
    console.log('the selected value is ' + value);
    if (value == 'addtestusdt') {
      this.addTokenToWallet();
    }
    if (value == 'testusdt') {
      this.getToken();
    }

    if (value == 'addnetwork') {
      this.addNetworkToWallet();
    }
  }

  /**
   *  Switch to Rinkeby Network by SwichEthereumChain method
   *  @reutrn void
   */
  // async onChangeNetwork(value: string) {
  //   if (typeof window.ethereum !== 'undefined') {
  //     try {
  //       await window.ethereum.request({
  //         method: 'wallet_switchEthereumChain',
  //         params: [{chainId: value}],
  //       });
  //     } catch (error) {
  //       console.log('Error while adding network to wallet');
  //     }
  //   }

  //   /**
  //    *  Check chain ID when newtwork change
  //    */
  //     if (window.ethereum) {
  //       window.ethereum.on('chainChanged', async () => {
  //         const chain = await this.web3Service.getWeb3().eth.getChainId()
  //         console.log("chain Id ==>", chain);
  //       })
  //     }
  // }

  async addTokenToWallet() {
    if (typeof window.ethereum !== 'undefined') {
      try {
        let result = await window.ethereum.request({
          method: 'wallet_watchAsset',
          params: {
            type: 'ERC20',
            options: {
              address: environment.TokenAddress,
              symbol: 'USDT',
              decimals: 18,
              image: '',
            },
          },
        });
        console.log('token add result', result);
      } catch (error) {
        console.log('Error while adding token to metamask');
      }
    }
  }

  async addNetworkToWallet() {
    if (typeof window.ethereum !== 'undefined') {
      try {
        let result = await window.ethereum.request({
          jsonrpc: '2.0',
          method: 'wallet_addEthereumChain',
          params: [
            {
              chainId: '0x89',
              chainName: 'Polygon Mainnet',
              rpcUrls: ['https://polygon-rpc.com/'],
              nativeCurrency: {
                name: 'MATIC',
                symbol: 'MATIC',
                decimals: 18,
              },
              blockExplorerUrls: ['https://polygonscan.com/'],
            },
          ],
        });
        console.log('Network added result', result);
        if (result == undefined) {
        }
      } catch (error) {
        console.log('Error while adding network to wallet');
      }
    }
  }
  setwalletAddress: any;
  walletAddress: any;
  async getToken() {
    console.log('', this.web3Service.getAccount());
    try {
      let walletAddress = this.web3Service.getAccount();
      this.setwalletAddress = walletAddress;
      localStorage.setItem('walletaddress', this.setwalletAddress);
      this.walletAddress = localStorage.getItem('walletaddress');
      console.log(this.walletAddress, 'walletAddress');
      await setTimeout(() => {
        let mintTokenResult = this.web3Service
          .artifactsToTokenContract(environment.TokenAddress)
          .methods.mint(
            walletAddress,
            this.web3Service.convertToSmallestUnit('1000')
          )
          .send({ from: walletAddress });
        console.log(mintTokenResult);
      }, 300);
    } catch (error) {
      console.log('Error while minting tokens to wallet');
      console.log(error);
    }
  }

  // connecting to metamask
  connectMetamask() {
    if (!window.ethereum) {
      alert('Please install metamask extension or use wallet connect');
    }
    this.web3Service.bootstrapWeb3().subscribe(
      (accounts: string[]) => {
        this.connected = true;
        $('#connectModal').hide();
        $('.modal-backdrop').remove();
        if (accounts.length === 0) {
          this.toastr.info('Please open Metamask to connect.');
        }
        let networkId = accounts[0] || '';
        this.networkId = networkId;
        // if (networkId) {
        //   if (this.redirectUrl == 'lending') {
        //     this.router.navigateByUrl('/home/lending');
        //   } else if (this.redirectUrl == 'borrow') {
        //     this.router.navigateByUrl('/home/borrow');
        //   } else {
        //     this.router.navigateByUrl('/');
        //   }
        // } else {
        //   this.router.navigateByUrl('/');
        // }
      },
      (err) => {
        console.log(err);
      }
    );
  }

  // wallet connect

  walletConnect() {
    this.web3Service.connectWallet().subscribe(
      (accounts: string[]) => {
        this.connected = true;
        $('#connectModal').hide();
        $('.modal-backdrop').remove();
        console.log(' ========== conect component =======');
        console.log(accounts);
        if (accounts.length === 0) {
          this.toastr.info('Please open walletconnect to connect.');
        }
        let networkId = accounts[0] || '';
        this.networkId = networkId;
        // if (networkId) {
        //   if (this.redirectUrl == 'lending') {
        //     this.router.navigateByUrl('/home/lending');
        //   } else if (this.redirectUrl == 'borrow') {
        //     this.router.navigateByUrl('/home/borrow');
        //   } else {
        //     this.router.navigateByUrl('/');
        //   }
        // } else {
        //   this.router.navigateByUrl('/');
        // }
      },
      (err) => {
        console.log(err);
      }
    );
  }

  // disconnecting from metamask wallet
  disconnectWallet() {
    console.log(this.connected);
    if (this.connected) {
      this.connected = !this.connected;
      this.networkId = '';
    }
  }
  changeNetwork(value: AvailableNetworks) {
    console.log(value);
    this.selectedNetwork = value;
    this._storeService.setnetwork(value);
    console.log('hello');
  }
  async OnnetworkButtonClick() {
    this.web3Service.onChangeNetwork(this.selectedNetwork);
  }
  logout() {
    localStorage.setItem('isLoginButton', 'false');

    this.router.navigate(['/home']);
    this.signedIn = false;
    localStorage.clear();
    localStorage.removeItem('phoneNo');
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    this.router.navigate['/home'];
  }
  bondsPage() {
    // this.router.navigateByUrl('/home/lend/india');
    window.location.href = '/home/lend/india';
  }
}
